var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-24 flex justify-between items-center px-3"},[_c('div',{staticClass:"w-24 h-24 flex-shrink-0 my-auto flex px-1"},[_c('a',{attrs:{"href":"/new"}},[_c('Logo')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }